import { Component, CUSTOM_ELEMENTS_SCHEMA, Input } from '@angular/core';
import { PartsManagementResponse } from '../../../models/parts-management-response.model';

@Component({
  selector: 'app-parts-management-operational-settings',
  imports: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './parts-management-operational-settings.component.html',
  styleUrl: './parts-management-operational-settings.component.scss',
})
export class PartsManagementOperationalSettingsComponent {
  @Input() partsManagementOperationalSettings!: PartsManagementResponse;
}
